<!-- 开启任务下拉列表的图标及非终态任务数标识 -->
<div
    #taskTooltip
    class="task-number badge-wrap"
    [nTooltip]="taskDropdown"
    nTooltipTrigger="click"
    nTooltipTheme="black"
    nTooltipPlacement="bottom"
    nTooltipOverlayClass="task-panel"
    [(nTooltipVisible)]="tooltipVisible"
    (nTooltipVisibleChange)="$event ? onPanelShow() : onPanelHide()"
>
    <div class="task-icon-wrap" [nTooltip]="isSimpleMode ? i18n.taskTip : null" nTooltipPlacement="bottom">
        <svg class="icon header-icon" *ngIf="taskDataMap[taskPanelStatus.Unfinished].noData">
            <use xlink:href="#app-icon-header-task-simple"></use>
        </svg>
        <!-- 任务运行时的动图 -->
        <img [src]="isSimpleMode ? '/assets/images/header-task-simple.gif' : '/assets/images/header-task.gif'"
            [class.hidden]="taskDataMap[taskPanelStatus.Unfinished].noData">
        <!-- 右上角的红点 -->
        <span class="badge" *ngIf="!hasAllTasksRead" [title]="i18n.unreadTaskTip"></span>
    </div>
</div>

<!-- 任务下拉列表 -->
<ng-template #taskDropdown>
    <div class="header">
        <span>
            {{i18n.title}}
        </span>
    </div>

    <div class="task-tabs">
        <ng-container *ngFor="let taskType of allTasks">
            <div class="task-tab-item">
                <a class="type-switch" (click)="tabSwitcher(taskType)" [ngClass]="tabStyle | fn :taskType :currentTaskType">
                    {{i18n[taskType]}}
                </a>
                <span class="unread-badge" *ngIf="taskDataMap[taskType].hasUnreadTasks"></span>
                <div class="tab-splitter"></div>
            </div>
        </ng-container>
    </div>

    <!-- 任务展示区 -->
    <div class="body">
        <!-- 加载中提示 -->
        <div class="loading" *ngIf="taskDataMap[currentTaskType].isLoading">
            <svg class="icon uploading">
                <use xlink:href="#icon-loading">
                </use>
            </svg>
        </div>

        <!-- 无数据提示 -->
        <div *ngIf="taskDataMap[currentTaskType].noData" style="
                margin-top: .1rem;
                margin-bottom: .1rem;">
            <div>
                {{i18n.noData}}
            </div>
        </div>

        <!-- 任务列表 -->
        <div *ngFor="let t of taskDataMap[currentTaskType].tasks"
            class="task" (click)="viewDetail(t)">
            <!-- 图标 -->
            <section class="state">
                <app-progress-bar style="width: 0.16rem; height: 0.16rem;"
                    *ngIf="shouldShowProgress(t)"
                    [percent]="calProgress(t)"
                    [nTooltip]="statusStr[t.taskStatus]">
                </app-progress-bar>
                <div *ngIf="!shouldShowProgress(t)" class="state-icon"
                    [ngClass]="getStateClass(t)"
                    [nTooltip]="statusStr[t.taskStatus]">
                </div>
            </section>
            <!-- 任务名称、对象名称 -->
            <section class="content">
                <p class="name" nTextTips>{{t.displayName}}</p>
                <p class="target" nTextTips [innerHTML]="replaceBlock(t.objName)"></p>
            </section>
            <section class="arrow"></section>
        </div>
    </div>

    <div class="foot">
        <a
            (click)="viewAllTasks()"
            class="view-all-link"
            style="
                color: white;
            "
        >
            {{i18n.viewAllTasks}}
        </a>
    </div>
</ng-template>
